export const SCALES = {
  pressure: {
    label: "Tekanan (hPa)",
    unit: "hPa",
    colors: ["#1e3a8a", "#2563eb", "#22d3ee", "#a3e635", "#facc15", "#f97316", "#dc2626"],
  },
  humidity: {
    label: "Kelembapan (%)",
    unit: "%",
    colors: ["#7c2d12", "#d97706", "#fde047", "#86efac", "#22c55e", "#0ea5e9", "#1e3a8a"],
  },
  temp: {
    label: "Suhu",
    unit: "°C",
    colors: ["#312e81", "#2563eb", "#22d3ee", "#86efac", "#facc15", "#f97316", "#dc2626", "#7f1d1d"],
  },
};

export const SCALAR_LAYERS = Object.keys(SCALES);

export const domainFor = (variable, grid) => {
  if (variable === "humidity") return [0, 100];
  if (variable === "temp") {
    if (!grid) return [15, 35];
    let lo = Math.floor(grid.min), hi = Math.ceil(grid.max);
    if (hi - lo < 6) {
      const mid = (lo + hi) / 2;
      lo = Math.floor(mid - 3);
      hi = Math.ceil(mid + 3);
    }
    return [lo, hi];
  }
  if (!grid) return [1000, 1024];
  let lo = Math.floor(grid.min), hi = Math.ceil(grid.max);
  if (hi - lo < 8) {
    const mid = (lo + hi) / 2;
    lo = Math.floor(mid - 4);
    hi = Math.ceil(mid + 4);
  }
  return [lo, hi];
};

const hex = (c) => [parseInt(c.slice(1, 3), 16), parseInt(c.slice(3, 5), 16), parseInt(c.slice(5, 7), 16)];

export const makeColorFn = (variable, grid) => {
  const { colors } = SCALES[variable];
  const [lo, hi] = domainFor(variable, grid);
  const rgb = colors.map(hex);
  const n = rgb.length - 1;
  return (v) => {
    const t = Math.min(1, Math.max(0, (v - lo) / (hi - lo || 1))) * n;
    const i = Math.min(n - 1, Math.floor(t));
    const f = t - i;
    const a = rgb[i], b = rgb[i + 1];
    return [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f, a[2] + (b[2] - a[2]) * f];
  };
};

export const gradientCss = (variable) => `linear-gradient(90deg, ${SCALES[variable].colors.join(",")})`;
